<template>
    <v-container fluid>
        <!-- row with dropdowns -->
        <v-layout align-center justify-center row fill-heignt>
            <!-- flex with selects -->
            <v-flex xs3>
                <!-- <div class="subheading">Timeframe</div> -->
                <v-select
                    :items="timeframes"
                    item-value="value"
                    item-text="title"
                    v-model="selectedTimefame"
                    label="Timeframe"
                    solo
                    height="35"
                ></v-select>
            </v-flex>
            <!-- disabled dropdowns -->
            <v-layout v-if="false">
                <v-flex xs2>
                    <v-select
                        v-model="selected_platforms"
                        :items="getPlatforms"
                        item-text="name"
                        item-value="external_id"
                        :menu-props="{maxHeight: '600', offsetY:true}"
                        label="Platform"
                        multiple
                        chips                            
                    >   
                        <!-- Adding Select/Unselect all row to dropdown -->
                        <v-list-tile
                            slot="prepend-item"
                            ripple
                            @click="selectAllPlatforms"
                            v-if="getPlatforms.length > 0"
                        >
                            <v-list-tile-title>{{select_all_platforms_label}}</v-list-tile-title>
                        </v-list-tile>
                        <v-divider
                            slot="prepend-item"
                            class="mt-2"
                        ></v-divider>
                    </v-select>
                </v-flex>
                <v-flex xs2>
                    <v-select
                        v-model="selected_advertisers"
                        :items="getAdvertisers"
                        item-text="name"
                        item-value="external_id"
                        :menu-props="{maxHeight: '600', offsetY:true}"
                        label="Advertiser"
                        multiple
                        chips
                    >
                        <template v-slot:selection="{ item, index }">
                            <v-chip v-if="index === 0 || index === 1 || index === 2">
                                <span>{{ item.name }}</span>
                            </v-chip>
                            <span
                                v-if="index === 3"
                                class="black--text body-1"
                            >(+{{ selected_advertisers.length - 3 }} more)</span>
                        </template>
                        <v-list-tile
                            slot="prepend-item"
                            ripple
                            @click="selectAllAdvertisers"
                            v-if="getAdvertisers.length > 0"
                        >
                            <v-list-tile-title>{{select_all_advertisers_label}}</v-list-tile-title>
                        </v-list-tile>
                        <v-divider
                            slot="prepend-item"
                            class="mt-2"
                        ></v-divider>
                    </v-select>
                </v-flex>
                <v-flex xs2>
                    <v-select
                        v-model="selected_campaigns"
                        :items="getCampaigns"
                        item-text="name"
                        item-value="external_id"
                        :menu-props="{maxHeight: '600', offsetY:true}"
                        label="Campaign"
                        multiple
                        chips
                    >
                        <template v-slot:selection="{ item, index }">
                            <v-chip v-if="index === 0 || index === 1">
                                <span>{{ item.name }}</span>
                            </v-chip>
                            <span
                                v-if="index === 2"
                                class="black--text body-1"
                            >(+{{ selected_campaigns.length - 2 }} more)</span>
                        </template>
                        <v-list-tile
                            slot="prepend-item"
                            ripple
                            @click="selectAllCampaigns"
                            v-if="getCampaigns.length > 0"
                        >
                            <v-list-tile-title>{{select_all_campaigns_label}}</v-list-tile-title>
                        </v-list-tile>
                        <v-divider
                            slot="prepend-item"
                            class="mt-2"
                        ></v-divider>
                    </v-select>
            </v-flex>
            </v-layout>
        </v-layout>
        <v-layout align-center justify-center row>
            <v-flex xs12 sm10 md6 lg3>
                <v-alert
                    :value="testAlerts || entitiesLoadError"
                    :dismissible="true"
                    v-if="!loading_results"
                    type="warning"
                >
                    Sorry, there was a problem loading options
                </v-alert>
                <v-alert
                    :value="testAlerts || responseError"
                    :dismissible="true"
                    v-if="!loading_results"
                    type="warning"
                >
                    Sorry, there was a problem loading data
                </v-alert>
                <v-alert
                    :value="testAlerts || responseDataEmpty"
                    :dismissible="true"
                    v-if="!loading_results"
                    type="info"
                >
                    No data available
                </v-alert>
            </v-flex>
        </v-layout>
        <br>
        <v-layout justify-center class="vld-parent">
            <loading 
                :active.sync="loading_results" 
                :can-cancel="false" 
                :is-full-page="false"
                loader="dots"
                color="#4caf50"
                :height="80"
                :width="80"
                :opacity="0.7"
            ></loading>
            <v-flex xs12 md10>
                <pivot
                    :data="processedData"
                    :fields="fields"
                    :row-fields="rowFields"
                    :col-fields="colFields"
                    :reducer="pivotReducer"
                    :default-show-settings="defaultShowSettings"
                    >
                    <template slot="value" slot-scope="{ value }">
                        <v-layout justify-space-around align-center>
                            <v-flex xs4>Clicks: <b>{{value.clicks.toLocaleString()}}</b></v-flex>
                            <v-flex xs4>Impressions: <b>{{value.impressions.toLocaleString()}}</b></v-flex>
                            <v-flex xs4>Conversions: <b>{{value.conversions.toLocaleString()}}</b></v-flex>
                        </v-layout>
                    </template>
                </pivot>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import axios from 'axios'
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import PivotTable from '@/components/vue-pivot/PivotTable'
import Pivot from '@/components/vue-pivot/Pivot'
import 'bootstrap/dist/css/bootstrap.min.css' // for vue-pivot-table
import { mapGetters } from 'vuex'

export default {
    components: { 
        Pivot,
        Loading
    },
    data() {
        return {
            // pivot data
            data_records: [],
            fields: [
                {
                getter: item => item.campaign_name,
                label: 'Campaign'
                }
            ],
            rowFields: [
                {
                getter: item => item.advertiser_name,
                label: 'Advertiser'
                }
            ],
            colFields: [
                {
                getter: item => item.platform_name,
                label: 'Platform'
                },
            ],
            // reducer: (sum, item) => sum + item[this.radio_option],
            defaultShowSettings: true,
            isDataLoading: false,

            // values and flags for "Select all" buttons
            all_platforms_selected: false,
            select_all_platforms_label: 'Select all',

            all_advertisers_selected: false,
            select_all_advertisers_label: 'Select all',

            all_campaigns_selected: false,
            select_all_campaigns_label: 'Select all',

            // loading flag
            loading_results: false,

            timeframes: [
                {title:'MTD', value:'mtd'},
                {title:'Last Month', value:'last_month'},
                {title:'30 Days', value:'thirty_days'},
                {title: '7 Days', value: 'seven_days'},
                {title: 'Yesterday', value: 'yesterday'}
            ],
            selectedTimefame:'mtd',            

            // arrays with selected entities
            selected_platforms:[],
            selected_advertisers:[],
            selected_campaigns:[],

            responseDataEmpty: false,
            responseError: false,
            
            // show alerts for testing
            testAlerts: false,
        }
    },
    methods: {
        selectAllPlatforms() {
            this.$nextTick(() => {
                if (this.all_platforms_selected) {
                    this.selected_platforms = []
                    this.all_platforms_selected = false
                    this.select_all_platforms_label = 'Select all'
                } else {
                    this.selected_platforms = this.getPlatforms.map(platform => platform.external_id)
                    this.all_platforms_selected = true
                    this.select_all_platforms_label = 'Unselect all'
                }
            })
        },
        selectAllAdvertisers() {
            this.$nextTick(() => {
                if (this.all_advertisers_selected) {
                    this.selected_advertisers = []
                    this.all_advertisers_selected = false
                    this.select_all_advertisers_label = 'Select all'
                } else {
                    this.selected_advertisers = this.getAdvertisers.map(advertiser => advertiser.external_id)
                    this.all_advertisers_selected = true
                    this.select_all_advertisers_label = 'Unselect all'
                }
            })
        },
        selectAllCampaigns() {
            this.$nextTick(() => {
                if (this.all_campaigns_selected) {
                    this.selected_campaigns = []
                    this.all_campaigns_selected = false
                    this.select_all_campaigns_label = 'Select all'
                } else {
                    this.selected_campaigns = this.getCampaigns.map(campaign => campaign.external_id)
                    this.all_campaigns_selected = true
                    this.select_all_campaigns_label = 'Unselect all'
                }
            })
        },
        gatherData() {
            this.loading_results = true
            this.responseDataEmpty = false
            this.responseError = false

            axios.get('admin/dashboard')
            .then(resp =>{
                this.data_records = resp.data
                if (!this.data_records) {
                    this.responseDataEmpty = true
                }
            })
            .catch(err =>{
                console.log(err)
                this.responseError = true
                this.data_records = {}
            })
            .then(() => {
                this.loading_results = false
            })
        },
        pivotReducer(sum, item) {
            sum.clicks += Number(item.clicks)
            sum.impressions += Number(item.impressions)
            sum.conversions += Number(item.conversions)
            return sum
        },
    },
    computed: {
        ...mapGetters([
            'getPlatforms',
            'getAdvertisers',
            'getCampaigns',
            'gotEntities',
            'mappedPlatforms',
            'mappedAdvertisers',
            'mappedCampaigns',
        ]),
        entitiesLoadError() {
            return !this.getPlatforms.length || !this.getAdvertisers.length || !this.getCampaigns.length
        },
        processedData() {
            let timeframe_data = this.data_records[this.selectedTimefame]

            if (timeframe_data && timeframe_data.length) {
                let mapped_platforms = this.mappedPlatforms
                let mapped_adverts = this.mappedAdvertisers
                let mapped_campaigns = this.mappedCampaigns

                let rows_copy = JSON.parse(JSON.stringify(timeframe_data))

                let out_rows = rows_copy.map(obj => {
                    if (obj.platform_id) {
                        obj.platform_name = mapped_platforms[obj.platform_id] ? mapped_platforms[obj.platform_id] : `N/A (id: ${obj.platform_id})`
                    } else {
                        obj.platform_name = ""
                    }
                    if (obj.advertiser_id) {
                        obj.advertiser_name = mapped_adverts[obj.advertiser_id] ? mapped_adverts[obj.advertiser_id] : `N/A (id: ${obj.advertiser_id})`
                    } else {
                        obj.advertiser_name = ""
                    }
                    if (obj.campaign_id) {
                        obj.campaign_name = mapped_campaigns[obj.campaign_id] ?  mapped_campaigns[obj.campaign_id] : `N/A (id: ${obj.campaign_id})`
                    } else {
                        obj.campaign_name = ""
                    }

                    return obj
                })

                return out_rows
            }

            return []
        }
    },
    created() {
        this.gatherData()

        if (!this.gotEntities) {
            this.$store.dispatch('fetchEntities')
        }
    }
}
</script>

<style>
.subcell {
    border: 1px solid #dee2e6;
}
.table.pivot thead th {
    text-align: center;
}
div.pivot  {
    /* display:block; */
    overflow-x:hidden;
}
</style>
